'use strict';

var React = require('react');
var AppStore$1 = require('../../../IconsAndImages/Images/Download/AppStore.js');
var Link = require('../../../node_modules/@material-ui/core/esm/Link/Link.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var AppStore = function AppStore(_ref) {
  var fill = _ref.fill;
  return React__default["default"].createElement(Link["default"], {
    href: "https://itunes.apple.com/us/app/housecall-pro/id692833651?mt=8"
  }, React__default["default"].createElement(AppStore$1, {
    fill: fill
  }));
};

module.exports = AppStore;
